import { useMemo } from "react";
import { useSelector, shallowEqual } from "react-redux";

const EMPTY_ARRAY = [];

/**
 * Custom hook to access global filter state
 * This provides a consistent way to access selectedClients and selectedBrands
 * across all components without having to import Redux hooks directly
 */
export const useGlobalFilters = () => {
  const selectedClients =
    useSelector((state) => state.selectedClients, shallowEqual) ?? EMPTY_ARRAY;
  const selectedBrands =
    useSelector((state) => state.selectedBrands, shallowEqual) ?? EMPTY_ARRAY;

  const brandIds = useMemo(
    () => selectedBrands.map((brand) => brand.id),
    [selectedBrands]
  );

  return {
    selectedClients,
    selectedBrands,
    // Helper to get brand IDs for API calls
    brandIds,
    // Helper to get client IDs for API calls
    clientIds: selectedClients,
    // Helper to check if any brands are selected
    hasSelectedBrands: selectedBrands.length > 0,
    // Helper to check if any clients are selected
    hasSelectedClients: selectedClients.length > 0,
  };
};

export default useGlobalFilters;
